export enum viewItemListMethod {
  standard = "standard",
  search = "ricerca",
  cart = "carrello",
  checkout = "checkout"
}
